export type HoSoTenFields = {
  firstName?: string | null
  lastName?: string | null
} | null | undefined

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** `needle` đã xuất hiện như một cụm từ trong `haystack` (biên khoảng trắng / `-`). */
const containsAsWord = (haystack: string, needle: string): boolean => {
  if (!needle) return false
  if (haystack === needle) return true
  const re = new RegExp(`(^|[\\s-])${escapeRegExp(needle)}(?=$|[\\s-])`)
  return re.test(haystack)
}

/** Bỏ prefix mã kiểu `NV106-` nếu còn sót trong firstName (data cũ trước migrate). */
export const stripMaNvPrefix = (raw: string): string =>
  String(raw || '')
    .trim()
    .replace(/^\s*NV\d+\s*-\s*/i, '')
    .trim()

/**
 * Gộp họ tên từ hồ sơ user (Auth: firstName = Họ, lastName = Tên).
 *
 * - Chuẩn: «Họ + Tên» = `firstName lastName`
 * - Data cũ: firstName = «NV###-Họ Đệm Tên» → strip mã; nếu first đã chứa last thì không nối trùng
 */
export const hoTenFromHoSo = (hoSo: HoSoTenFields): string => {
  const firstRaw = String(hoSo?.firstName ?? '').trim()
  const last = String(hoSo?.lastName ?? '').trim()
  const first = stripMaNvPrefix(firstRaw) || firstRaw
  if (!first) return last
  if (!last) return first
  if (containsAsWord(first, last)) return first
  if (containsAsWord(last, first)) return last
  return `${first} ${last}`.trim()
}

/**
 * Label nhân viên: `NV106-ANHNHH(Nguyễn Hữu Hồ Anh)`
 */
export function formatNhanVienLabel(nv: {
  username?: string | null
  hoTen?: string | null
  hoSo?: HoSoTenFields
  profile?: HoSoTenFields
  userProfile?: HoSoTenFields
  fullName?: string | null
} | null | undefined): string {
  if (!nv) return ''
  const ma = String(nv.username ?? '').trim()
  const ten =
    String(nv.hoTen ?? '').trim() ||
    String(nv.fullName ?? '').trim() ||
    hoTenFromHoSo(nv.hoSo ?? nv.profile ?? nv.userProfile ?? null)
  if (ma && ten) return `${ma}(${ten})`
  return ma || ten
}

/** Cột người bán / người tạo: cùng chuẩn `username(Họ Tên)`. */
export function tenNguoiHienThi(nv: {
  username?: string | null
  hoTen?: string | null
  fullName?: string | null
  hoSo?: HoSoTenFields
  profile?: HoSoTenFields
  userProfile?: HoSoTenFields
} | null | undefined): string {
  return formatNhanVienLabel(nv)
}
